//this function returns an object containing all the reducers of our project.

const rootReducer = () => {
  return {
    //allReducer
  };
};

export default rootReducer;
